export default class BaseResourceWriter {
    constructor(languageCode,
                trimWhitespace,
                replacePlaceholders,
                replaceFullWidthPlaceholders,
                replaceWhitespaceCharacters,
                retainEmptyValue,
                header) {
        this.languageCode = languageCode;
        this.trimWhitespace = trimWhitespace;
        this.replacePlaceholders = replacePlaceholders;
        this.replaceFullWidthPlaceholders = replaceFullWidthPlaceholders;
        this.replaceWhitespaceCharacters = replaceWhitespaceCharacters;
        this.retainEmptyValue = replaceWhitespaceCharacters;
        this.header = header;
    }
}